import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconSignOutStyle0 = cosmosIconCss;

const CosmosIconSignOut$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSignOut extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a8bc2a1893970e8ed0e32883e2f8f823bead8a2c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ca1b664f4a614e562349399b9d94fe4cb3e9f4ff', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '239a394f21e266b070d30af0e7079b1680fe2f66', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.5 16.5v3a.5.5 0 0 1-.5.5H2.5a.5.5 0 0 1-.5-.5v-17a.5.5 0 0 1 .5-.5H13a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-2H3.5v15H12v-2a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5Zm2.223-1.444a.482.482 0 0 1-.298-.446v-2.86h-8.89c-.295 0-.535-.224-.535-.5v-.5c0-.276.24-.5.536-.5h8.89V7.39a.482.482 0 0 1 .823-.341l3.61 3.61a.482.482 0 0 1 0 .682l-3.61 3.61a.482.482 0 0 1-.526.105Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconSignOutStyle0; }
}, [1, "cosmos-icon-sign-out", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-sign-out"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-sign-out":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSignOut$1);
            }
            break;
    } });
}

const CosmosIconSignOut = CosmosIconSignOut$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSignOut, defineCustomElement };
